import { render, staticRenderFns } from "./CurrentVideoList.vue?vue&type=template&id=84f338f8&"
import script from "./CurrentVideoList.vue?vue&type=script&lang=js&"
export * from "./CurrentVideoList.vue?vue&type=script&lang=js&"
import style0 from "./CurrentVideoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports